<template>
  <v-dialog v-if="isAdmin" v-model="showModal" @keydown.esc="toggleModal" max-width="500px" persistent>
    <v-btn slot="activator" @click.native="openModal" color="success" depressed dark>Novo Filtro</v-btn>

    <v-card>
      <v-card-title>
        <span v-if="selectedItem.id" class="headline">Editar Filtro</span>
        <span v-else class="headline">Criar Filtro</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-flex xs12>
          <v-text-field type="number" min="0" v-model="selectedItem.order" label="Ordenação"></v-text-field>
          <v-text-field v-model="selectedItem.title" label="Título"></v-text-field>
          <v-text-field v-model="selectedItem.description" label="Descrição"></v-text-field>
        </v-flex>
      </v-card-text>

      <v-card-actions>
        <v-btn color="grey" flat @click.native="toggleModal">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" depressed @click.native="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { db } from '@/db'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FilterForm',

  computed: {
    ...mapGetters(['showModal', 'selectedItem']),
    ...mapGetters('auth', ['isAdmin'])
  },

  data () {
    return {
      filter: {
        order: 0,
        title: '',
        description: ''
      }
    }
  },

  methods: {
    ...mapActions(['toggleModal', 'setSelectedItem']),

    openModal () {
      this.setSelectedItem(this.filter)
      this.toggleModal()
    },

    save () {
      let _this = this

      this.selectedItem.order = parseInt(this.selectedItem.order)

      if (this.selectedItem.id !== undefined) {
        const updatedAt = new Date()
        let currentDocRef = db.collection('filters').doc(this.selectedItem.id)

        currentDocRef.set({
          ...this.selectedItem,
          updatedAt
        }).then(() => _this.toggleModal())
      } else {
        const createdAt = new Date()

        db.collection('filters').add({
          ...this.selectedItem,
          categoryId: this.$route.params.categoryId,
          subcategoryId: this.$route.params.subcategoryId,
          createdAt
        }).then(() => _this.toggleModal())
      }

      this.filter = {
        title: '',
        description: ''
      }
    }
  }
}
</script>
